<template>
  <div>
    <Loading v-if="initialLoad"></Loading>
    <Layout v-else>
      <div class="pt-4">
        <h3 style="font-weight: bold">Agent List</h3>
      </div>
      <section class="pt-5">
        <Overview class="overview">
          <b-col slot="total-agents">
            <b-card class="rc-card">
              <p>Total Number of Agents</p>
              <h3 style="margin-bottom: 4rem">
                <ICountUp
                  :delay="delay"
                  :endVal="totalAgents"
                  :options="options"
                  @ready="getTotalAgents"
                />
              </h3>
              <p style="font-size: 0.875rem; display: none">
                <span>+18%</span>
                <span class="grey-color pl_4">from last month</span>
              </p>
            </b-card>
          </b-col>

          <p slot="card-1-title">Pinpad Active Agents</p>
          <vc-donut slot="card-1-val" :sections="pinpadChart" :size="size">
            <p class="active-agents" style="color: #34b53a">
              {{ activePinpadAgents }}
            </p>
            <p class="total-agents">/{{ totalPinpadAgents }}</p>
          </vc-donut>

          <p slot="card-2-title">POS Active Agents</p>
          <vc-donut slot="card-2-val" :sections="posChart" :size="size">
            <p class="active-agents" style="color: #f5a623">
              {{ activePosAgents }}
            </p>
            <p class="total-agents">/{{ totalPosAgents }}</p>
          </vc-donut>

          <b-col>
            <b-card class="rc-card">
              <p>Accounts Active Agent</p>
              <vc-donut :sections="accountsChart" :size="size">
                <p class="active-agents" style="color: #f21919">
                  {{ activeAccountsAgents }}
                </p>
                <p class="total-agents">/{{ totalAccountsAgents }}</p>
              </vc-donut>
              <p class="fs-overview"></p>
            </b-card>
          </b-col>
          <!-- <span></span> -->
        </Overview>
      </section>
      <section class="pt-5">
        <TransactionsList>
          <b-form-input
            slot="search-bar"
            type="search"
            placeholder="Search by agent id"
            v-model="searchValue"
            @input="getParameter"
            trim
          />
          <b-button slot="search-btn" variant="primary" @click="applyFilter"
            >Search</b-button
          >
          <span slot="entries-no"
            >{{ entriesShown }} of {{ totalEntries }} entries</span
          >
          <b-form-input
            slot="start-range"
            class="trans-status"
            type="text"
            placeholder="Value"
            trim
          />
          <b-form-input
            slot="end-range"
            class="trans-status"
            type="text"
            placeholder="Value"
            trim
          />
          <b-form-input
            slot="status-input"
            class="trans-status"
            type="text"
            placeholder="Value"
            trim
          />
          <b-form-checkbox
            slot="save-default"
            class="save-filter"
            id="save-filter"
          >
            Save as default filter
          </b-form-checkbox>
          <b-button
            slot="clear-btn"
            class="btn-alt filter-btn"
            block
            variant="primary"
            @click="clearFilter"
          >
            Clear
          </b-button>
          <b-button
            slot="apply-btn"
            slot-scope="{ closeModal }"
            class="filter-btn"
            block
            variant="primary"
            @click="
              closeModal();
              applyFilter();
            "
          >
            Apply
          </b-button>
          <b-table
            slot="table"
            hover
            responsive
            :items="agentListTable"
            :filter="filter"
            :busy="isBusy"
            :empty-filtered-html="emptyImg"
            show-empty
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle mr-1"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
          </b-table>
          <b-pagination-nav
            slot="pagination"
            class="d-flex justify-content-end rc-pagination"
            :class="{ 'rc-pagination': rcPagination }"
            :link-gen="linkGen"
            :number-of-pages="totalPages"
            :disabled="isBusy"
            prev-text="Previous"
            next-text="Next"
            use-router
            @change="removeClass"
          ></b-pagination-nav>
        </TransactionsList>
      </section>
    </Layout>
  </div>
</template>

<script>
import Donut from "vue-css-donut-chart";
import "vue-css-donut-chart/dist/vcdonut.css";
import Vue from "vue";
import Loading from "@/components/Loading.vue";
import Layout from "@/components/Layout.vue";
import TransactionsList from "@/components/TransactionsList.vue";
import Overview from "@/components/Overview.vue";
import ICountUp from "vue-countup-v2";
import { mapState, mapActions } from "vuex";
import { appDataMixin } from "@/mixins/appData";
Vue.use(Donut);

export default {
  name: "AgentList",
  mixins: [appDataMixin],
  components: {
    Loading,
    Layout,
    Overview,
    ICountUp,
    TransactionsList,
  },
  data() {
    return {
      agentId: "",
      size: 100,
      pinpadChart: [{ value: 0, color: "#34B53A" }],
      posChart: [{ value: 0, color: "#F5A623" }],
      accountsChart: [{ value: 0, color: "#F21919" }],
    };
  },
  computed: {
    ...mapState({
      initialLoad: (state) => state.agentList.initialLoad,
      refresh: (state) => state.agentList.refresh,
      isBusy: (state) => state.agentList.busy,

      totalAgents: (state) => state.agentList.analytics.agentsCount,
      totalPages: (state) => state.agentList.list.last_page,
      totalEntries: (state) => state.agentList.list.total,
      entriesShown: (state) =>
        state.agentList.list.to !== null ? state.agentList.list.to : 0,

      totalPinpadAgents: (state) =>
        state.agentList.analytics.total_agents_pinpad,
      activePinpadAgents: (state) => state.agentList.analytics.pinpad_active,

      totalPosAgents: (state) => state.agentList.analytics.total_agents_pos,
      activePosAgents: (state) => state.agentList.analytics.pos_active,

      totalTransferAgents: (state) =>
        state.agentList.analytics.total_agents_transfer,
      activeTransferAgents: (state) =>
        state.agentList.analytics.transfer_active,

      totalAccountsAgents: (state) =>
        state.agentList.analytics.total_agents_account,
      activeAccountsAgents: (state) =>
        state.agentList.analytics.accounts_active,

      agentListTable: (state) => {
        if (state.agentList.list.data.length === 0) {
          return [
            {
              No_data: "No data to be displayed",
            },
          ];
        } else {
          if (Array.isArray(state.agentList.list.data)) {
            return state.agentList.list.data;
          } else {
            return Array.prototype.push(state.agentList.list.data);
          }
        }
      },
    }),
  },
  methods: {
    ...mapActions({
      getAgentList: "agentList/getAgentList",
      getAgentListAnalytics: "agentList/getAgentListAnalytics",
    }),
    getTodayData() {},
    getTotalAgents(instance) {
      const that = this;
      instance.update(that.totalAgents);
    },
    getRatio() {
      this.totalPinpadAgents === 0
        ? (this.pinpadChart[0].value = 0)
        : (this.pinpadChart[0].value =
            (this.activePinpadAgents / this.totalPinpadAgents) * 100);

      this.totalPosAgents === 0
        ? (this.posChart[0].value = 0)
        : (this.posChart[0].value =
            (this.activePosAgents / this.totalPosAgents) * 100),
        // eslint-disable-next-line prettier/prettier

        this.totalAccountsAgents === 0
          ? (this.accountsChart[0].value = 0)
          : (this.accountsChart[0].value =
              (this.activeAccountsAgents / this.totalAccountsAgents) * 100);
    },
  },
  created() {
    document.title = "Agent List | ReadyCash Aggregator Portal";
    this.getAgentList({
      page: this.page ? this.page : 1,
    });
    this.getAgentListAnalytics().then(() => {
      this.getRatio();
    });
  },
  updated() {
    console.log(this.agentId);
  },
};
</script>

<style lang="scss" scoped>
.agents-trans-select {
  width: 10vw;
  margin-right: 1rem;
}
.search-form input {
  border-radius: 5px;
}
.active-agents {
  font-size: 1.8rem;
  padding-top: 0;
  margin-top: -0.3rem;
}

.total-agents {
  padding-top: 0;
  font-size: 1.2rem;
}
.cdc-container {
  margin-bottom: -2.2rem;
}
</style>
